import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import { Home, LayoutGrid, Car, ShoppingCart, User } from "lucide-react";
import { useCart } from "../context/CartContext";
import { useAuth } from "../context/AuthContext";

const ITEMS = [
  { to: "/", label: "Accueil", icon: Home, id: "home", exact: true },
  { to: "/recherche?q=", label: "Catalogue", icon: LayoutGrid, id: "catalog", match: (p) => p.startsWith("/recherche") || p.startsWith("/categorie") || p.startsWith("/produit") },
  { to: "/vehicule", label: "Véhicule", icon: Car, id: "vehicle" },
  { to: "/panier", label: "Panier", icon: ShoppingCart, id: "cart" },
  { to: "/compte", label: "Compte", icon: User, id: "account", match: (p) => p.startsWith("/compte") || p.startsWith("/connexion") },
];

export const MobileBottomNav = () => {
  const { count } = useCart();
  const { user } = useAuth();
  const { pathname } = useLocation();
  return (
    <nav data-testid="mobile-bottom-nav" className="bottom-nav md:hidden fixed bottom-0 inset-x-0 z-40 bg-[#0D0F14]/95 backdrop-blur-md border-t border-[#1E232D]">
      <div className="grid grid-cols-5">
        {ITEMS.map((it) => {
          const to = it.id === "account" && !user ? "/connexion" : it.to;
          const active = it.match ? it.match(pathname) : it.exact ? pathname === "/" : pathname.startsWith(it.to);
          return (
            <NavLink key={it.id} to={to} data-testid={`bottom-nav-${it.id}`} className={`relative flex flex-col items-center justify-center gap-0.5 py-2 text-[10px] font-bold uppercase tracking-wide transition-colors active:scale-95 ${active ? "text-[#FF3B3B]" : "text-slate-400"}`}>
              {active && <span className="absolute top-0 w-8 h-0.5 rounded-full bg-[#E01F1F] shadow-[0_0_10px_#E01F1F]" />}
              <span className="relative">
                <it.icon size={21} strokeWidth={active ? 2.2 : 1.8} />
                {it.id === "cart" && count > 0 && <span data-testid="bottom-nav-cart-count" className="absolute -top-1.5 -right-2.5 min-w-[18px] h-[18px] px-1 rounded-full bg-[#E01F1F] text-white text-[10px] font-extrabold flex items-center justify-center">{count}</span>}
              </span>
              {it.label}
            </NavLink>
          );
        })}
      </div>
    </nav>
  );
};

export default MobileBottomNav;
